"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Accordion_1 = __importStar(require("components/design-system/accordion/Accordion"));
const SmallToggleSwitchPurple_1 = __importDefault(require("components/shared/ToogleSwitch/SmallToggleSwitchPurple"));
const Header = ({ title, subTitle, toggleCallback, toggleCy = 'toggle-card', isReadOnly, disabled }) => {
    const { setIsOpen, isOpen } = (0, Accordion_1.useAccordion)() || {};
    const toggleOpen = () => {
        if (!setIsOpen)
            return;
        setIsOpen(!isOpen);
        toggleCallback && toggleCallback(!isOpen);
    };
    return (react_1.default.createElement("div", { className: "flex flex-row space-between items-center px-[16px] py-[16px]" },
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("p", { className: `typography-h400 ${disabled ? 'text-n-700' : ' text-n-900'}` }, (0, HelperUtils_1.getObjectiveLocale)(title)),
            react_1.default.createElement("p", { className: `typography-paragraph  ${disabled ? 'text-n-600' : 'text-n-900'}` }, (0, HelperUtils_1.getObjectiveLocale)(subTitle))),
        react_1.default.createElement(SmallToggleSwitchPurple_1.default, { isChecked: isOpen, idStr: "toggle-maximum-peers", onChange: toggleOpen, disabled: isReadOnly || disabled, dataCy: toggleCy })));
};
const ToggledCardAccordion = ({ title, subTitle, toggleCallback, isOpen, children, clearContentSpace, toggleCy, isReadOnly, disabled, customClass }) => {
    return (react_1.default.createElement(Accordion_1.default, { useBorder: true, useBgColor: true, customClass: `mt-[16px] ${disabled ? 'bg-n-200 cursor-not-allowed' : ''} ${customClass ? customClass : ''}`, contentOpen: isOpen, onChange: () => null },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Accordion_1.default.Header, { useWrapperClick: false, useCustomHeader: true },
                react_1.default.createElement(Header, { title: title, subTitle: subTitle, toggleCallback: toggleCallback, toggleCy: toggleCy, isReadOnly: isReadOnly, disabled: disabled })),
            react_1.default.createElement(Accordion_1.default.Content, { customSpaceClass: `${clearContentSpace ? ' ' : 'px-[24px] pb-[24px]'}` }, children ? children : react_1.default.createElement(react_1.default.Fragment, null)))));
};
exports.default = ToggledCardAccordion;
